import React, { useEffect, useState } from "react";
import "./AddBusDataModal.css";
import AddAgencyModalLogo from "../../assets/images/addAgencyModalLogo.svg";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import * as yup from "yup";

import "react-phone-input-2/lib/bootstrap.css";
import { CommonDate, CommonDropdown, CommonInputField } from "../common-input";
import { useFormik } from "formik";
import { addBusData } from "../../services/bus.data.service";
import moment from "moment";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { TwoSection } from "../common-grid";
import { useMediaQuery } from "react-responsive";
import { BUS_TECHNOLOGY } from "../../constants/constant.data";

const AddBusDataModal = ({ toggleModal, allBuses }) => {
  const [selectedTechnology, setSelectedTechnology] = useState([]);
  const isMobile = useMediaQuery({
    query: "(max-width: 800px)",
  });
  const { errorToast, successToast, toastRef } = useToast();
  const { currentUser } = useSelector((state) => state.user);
  const { allAgencies } = useSelector((state) => state.agencies);
  const schema = yup.object().shape({
    agencyId: yup
      .string()
      .test("requiredForAdmin", "Agency is required", function (value) {
        if (currentUser?.role === "admin") {
          return !!value;
        }
        return true;
      }),
    busId: yup.string("Add Bus").required("Bus is required"),
    distanceTravelled: yup.string("Enter distance travelled"),
    energyCost: yup.string("Enter energy cost"),
    date: yup.string().required("Date is required"),
    efficiency: yup.string("Enter consumtion rate"),
    energyUsed: yup.string("Enter energy used"),
    carBrokeDown: yup.string(""),
  });

  const handleSubmit = async (values) => {
    addBusData({ ...values, date: moment(values.date).format("YYYY-MM-DD") })
      .then((res) => {
        successToast(res?.data?.message);
        toggleModal();
      })
      .catch((err) => {
        errorToast(err);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      agencyId: "",
      busId: "",
      distanceTravelled: "",
      energyCost: "",
      date: "",
      efficiency: "",
      energyUsed: "",
      carBrokeDown: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleKgUnit = (labelText) => {
    return (
      <span>
        {labelText} (kg H<sub>2</sub>)
      </span>
    );
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div className="modalBusData">
        <div className="modalInternalsBusData">
          <img
            className="logoModal"
            src={AddAgencyModalLogo}
            alt="ModalLogo"
          ></img>
          <br />
          <span className="modalHeading">Add Bus Data</span>
          <br />
          <span className="headingPlaceholder"></span>

          <div className="inputFieldBoxBusData">
            {currentUser?.role === "admin" && (
              <div className="noBusesBoxBusData">
                <div className="noBox">
                  <strong>Select Agency</strong>
                  <br />
                  <CommonDropdown
                    formik={formik}
                    name="agencyId"
                    optionArray={allAgencies}
                    style={{
                      marginTop: "7px",
                      width: !isMobile ? "235px" : "100%",
                    }}
                    optionKey="_id"
                    optionLabel="name"
                    placeholder="Select Agency"
                    label="Agency"
                    formikChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("busId", "");
                    }}
                  />
                </div>
              </div>
            )}

            <TwoSection
              firstSection={
                <CommonDropdown
                  name="busId"
                  // formik={formik}
                  onChange={(e) => {
                    formik.handleChange(e);
                    const selectedBusTechnology = allBuses?.find(
                      (x) => x._id === e.target?.value
                    )?.technology;
                    setSelectedTechnology(
                      BUS_TECHNOLOGY.filter(
                        (x) => x.key === selectedBusTechnology
                      )
                    );
                  }}
                  optionArray={
                    currentUser?.role === "admin"
                      ? allBuses?.filter(
                          (bus) => bus.agencyId === formik.values.agencyId
                        )
                      : allBuses?.filter((bus) =>
                          bus.agencyId === currentUser?.parentId
                            ? currentUser?.parentId
                            : currentUser?._id
                        )
                  }
                  optionKey="_id"
                  optionLabel="busNumberPlate"
                  placeholder="Select Bus"
                  label="Bus"
                  style={{
                    marginTop: "7px",
                    width: !isMobile ? "235px" : "100%",
                  }}
                />
              }
              firstLabel="Select Bus"
              secondSection={
                <CommonDate
                  placeholder="Click here to select a date"
                  formik={formik}
                  name="date"
                  style={{
                    marginTop: "7px",
                    width: !isMobile ? "235px" : "100%",
                  }}
                  isNew={true}
                />
              }
              secondLabel="Post Date"
            />

            <TwoSection
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="500 km"
                  name="distanceTravelled"
                  type="number"
                />
              }
              firstLabel="Distance Travelled (km)"
              secondSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder={
                    selectedTechnology?.length ? `E.g : 4` : "400 kWh"
                  }
                  name="energyUsed"
                  type="number"
                />
              }
              secondLabel={
                selectedTechnology?.length
                  ? selectedTechnology[0]?.dataUnit === "(kg H2)"
                    ? handleKgUnit(`${selectedTechnology[0]?.dataLabel} Used`)
                    : `${selectedTechnology[0]?.dataLabel} Used ${selectedTechnology[0]?.dataUnit}`
                  : "Energy Used (kWh)"
              }
            />

            <TwoSection
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder={selectedTechnology?.length ? `E.g : 4` : "4 kWh"}
                  name="efficiency"
                  type="number"
                />
              }
              firstLabel={
                selectedTechnology?.length
                  ? selectedTechnology[0]?.dataUnit === "(kg H2)"
                    ? handleKgUnit(`${selectedTechnology[0]?.dataLabel} Usage`)
                    : `${selectedTechnology[0]?.dataLabel} Usage ${selectedTechnology[0]?.dataUnit}`
                  : "Consumption Rate (km)"
              }
              secondSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="4 C$"
                  name="energyCost"
                  type="number"
                />
              }
              secondLabel={
                selectedTechnology?.length
                  ? `${selectedTechnology[0]?.dataLabel} Cost (C$)`
                  : "Energy cost (C$)"
              }
            />
          </div>
          <div className="inputFieldBoxBusData">
            <strong>Did the vehicle breakdown?</strong>
            <br />
            <CommonDropdown
              name="carBrokeDown"
              formik={formik}
              optionArray={[
                {
                  name: "Yes",
                  key: "Yes",
                },
                {
                  name: "No",
                  key: "No",
                },
              ]}
              optionKey="key"
              optionLabel="name"
              placeholder="Did the vehicle breakdown?"
              label="Did the vehicle breakdown?"
              style={{
                marginTop: "7px",
                width: "100%",
              }}
            />
          </div>

          <div className="addBackBoxBusData">
            <div className="addButton">
              <Button
                label="Add"
                style={{ background: "#1C9894", width: "140px", border: "0" }}
                onClick={formik.handleSubmit}
              />
            </div>
            <div className="addButton">
              <Button
                label="Back"
                style={{
                  background: "#FFFFFF",
                  width: "140px",
                  color: "#1C9894",
                  marginLeft: "20px",
                  borderColor: "#1C9894",
                }}
                onClick={() => {
                  toggleModal(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(true);
        }}
      />
    </>
  );
};

export default AddBusDataModal;
